<template>
<div>
<v-btn fab fixed style="margin-top:-25px" color="warning" :loading="saveLoad" :disabled="saveLoad" @click.native="save()"><v-icon>mdi-content-save</v-icon></v-btn>
<v-container style="margin-top: 64px">
    <v-flex xs12 class="text-center" style="margin-top: -30px">
        <h2>Avis mortuaire</h2>
    </v-flex>
    <v-layout row wrap>
        <v-flex lg12 xl6>
            <v-layout style="border:2px dotted red" row wrap>
                <v-flex xs8>
                    <v-radio-group v-model="avis.colonne" row>
                        <v-radio label="2 colonnes" value="2" ></v-radio>
                        <v-radio label="4 colonnes" value="4"></v-radio>
                    </v-radio-group>
                </v-flex>
                <v-flex xs4>
                    <v-text-field filled type="date" v-model="avis.dateParution" label="Date de parution"></v-text-field>
                </v-flex>
                <v-flex xs8 style="margin-top:-40px">
                    <v-radio-group v-model="avis.photo" row>
                        <v-radio label="avec photo" value="avec" ></v-radio>
                        <v-radio label="sans photo" value="sans"></v-radio>
                    </v-radio-group>
                </v-flex>
                <v-flex xs4></v-flex>
                <v-flex xs12>
                    <v-select filled v-model="avis.adresseFact" multi-line label="Adresse de facturation" :items="adrFact"></v-select>
                </v-flex>
            </v-layout>
            <v-flex xs12>
                <v-radio-group v-model="avis.symbole" row>
                    <v-radio label="croix" value="croix" ></v-radio>
                    <v-radio label="palme" value="palme"></v-radio>
                    <v-radio label="colombe" value="colombe"></v-radio>
                    <v-radio label="aucun" value="aucun"></v-radio>
                </v-radio-group>
            </v-flex>
            <v-flex xs12>
                <v-combobox filled v-model="avis.petitText" multi-line label="Petit texte" :items="petitText"></v-combobox>
            </v-flex>
            <v-flex xs12>
                <v-textarea outline type="text" v-model="avis.famille" rows=10 label="Famille"></v-textarea>
            </v-flex>
            <v-layout row wrap>
                <v-flex xs6>
                    <v-combobox filled v-model="avis.ainsi" multi-line label="ainsi que ..." :items="ainsi"></v-combobox>
                </v-flex>
                <v-flex xs6>
                    <v-combobox filled v-model="avis.ontLe" multi-line label="ont le ..." :items="ontLe"></v-combobox>
                </v-flex>
                <v-flex xs12>
                    <v-textarea filled rows=3 v-model="avis.denom" label='Dénomination'></v-textarea>
                </v-flex>
                <v-flex xs4>
                    <v-combobox filled v-model="avis.quiSest" multi-line label="qui s'est ..." :items="quiSest"></v-combobox>
                </v-flex>
                <v-flex xs4>
                    <v-text-field filled v-model="avis.dateDeces" label="date de décès" disabled></v-text-field>
                </v-flex>
                <v-flex xs4>
                    <v-combobox filled v-model="avis.age" multi-line label="age" :items="age"></v-combobox>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs6>
                    <v-combobox filled v-model="avis.apres" multi-line label="après ..." :items="apres"></v-combobox>
                </v-flex>
                <v-flex xs6>
                    <v-combobox filled v-model="avis.reconfort" multi-line label="réconfort ..." :items="reconfort"></v-combobox>
                </v-flex>
                <v-flex xs12>
                    <v-tooltip top>
                        <template v-slot:activator ="{on, attrs}">
                            <v-btn @click="createVeillCerem('ceremonie')" v-on="on" v-bind="attrs" style="margin-left: -45px; z-index: 1" absolute dark small fab color="purple"><v-icon>mdi-refresh</v-icon></v-btn>
                        </template>
                        <span>Recharger les données depuis services funèbres</span>
                    </v-tooltip>
                    <v-textarea filled type="text" v-model="avis.ceremonie" rows=2 label="Céréméonie"></v-textarea>
                </v-flex>
                <v-flex xs12>
                    <v-tooltip top>
                        <template v-slot:activator ="{on, attrs}">
                            <v-btn @click.native="createVeillCerem('veillance')" v-on="on" v-bind="attrs" style="margin-left: -45px; z-index: 1" absolute dark small fab color="purple"><v-icon>mdi-refresh</v-icon></v-btn>
                        </template>
                        <span>Recharger les données depuis services funèbres</span>
                    </v-tooltip>
                    <v-textarea filled type="text" v-model="avis.veillance" rows=2 label="Veillée / Présence"></v-textarea>
                </v-flex>
                <v-flex xs12>
                    <v-combobox filled v-model="avis.dons" multi-line label="dons" :items="dons"></v-combobox>
                </v-flex>
                <v-flex xs12>
                    <v-combobox filled v-model="avis.adresseFam" multi-line label="Adresse de la famille" :items="adrFam"></v-combobox>
                </v-flex>
                <v-flex xs12>
                    <v-combobox filled v-model="avis.fairePart" multi-line label="faire-part" :items="fairePart"></v-combobox>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-flex lg12 xl6>
            <h2 class="text-center">Prix ~ {{avis.prix}} CHF</h2>
            <v-layout :style="'border:2px dotted black; width: ' + colonne + 'px; font-size: 18px; position: sticky; top: 150px; margin:0 auto'" row wrap justify-center ref="test">
                <v-flex xs3 v-if="avis.colonne==4" style="text-align:center">
                    <img v-if="avis.symbole=='croix'" src="../assets/croix.jpg" alt="logo" height="75px">
                    <img v-if="avis.symbole=='palme'" src="../assets/palme.jpg" alt="logo" height="40px" style="margin-top:20px">
                    <img v-if="avis.symbole=='colombe'" src="../assets/colombe.jpg" alt="logo" height="85px">
                </v-flex>
                <v-flex xs9 v-if="avis.colonne==4">
                    <div><em>{{avis.petitText}}</em></div>
                </v-flex>        
                <v-flex xs12 v-if="avis.colonne==2" style="text-align:center">
                    <img v-if="avis.symbole=='croix'" src="../assets/croix.jpg" alt="logo" height="75px">
                    <img v-if="avis.symbole=='palme'" src="../assets/palme.jpg" alt="logo" height="40px" style="margin-top:20px">
                    <img v-if="avis.symbole=='colombe'" src="../assets/colombe.jpg" alt="logo" height="85px">
                </v-flex>
                <v-flex xs12 v-if="avis.colonne==2 && avis.photo=='avec'" style="text-align:center">
                    <v-img :src="'/PHP/ajax/getPics.php?name=' + defunt.photo" height="200px"></v-img>
                </v-flex>        
                <v-flex xs12 v-if="avis.colonne==2">
                    <div><em>{{avis.petitText}}</em></div>
                </v-flex>        
                <v-flex xs12 v-if="avis.photo!='avec' || avis.colonne==2">
                    <pre style="font-family: 'Roboto'; white-space: pre-wrap;">{{avis.famille}}</pre>
                </v-flex>
                <v-flex xs8 v-if="avis.photo=='avec' && avis.colonne==4">
                    <pre style="font-family: 'Roboto'; white-space: pre-wrap;">{{avis.famille}}</pre>
                </v-flex>
                <v-flex xs4 v-if="avis.photo=='avec' && avis.colonne==4">
                    <v-img :src="'/PHP/ajax/getPics.php?name=' + defunt.photo" height="200px"></v-img>
                </v-flex>
                <v-flex xs12 v-if="avis.ainsi!=''">
                    <div>{{avis.ainsi + ', ' + avis.ontLe }}</div>
                </v-flex>
                <v-flex xs12 class="text-center" style="font-size: 32px; line-height: 32px">
                    <div><pre style="font-family: 'Roboto'"><strong>{{avis.denom}}</strong></pre></div>
                </v-flex>
                <v-flex xs12 v-if="avis.quiSest!=''">
                    <div>{{avis.quiSest + ' ' + avis.dateDeces + ', ' + avis.age + ', ' + avis.apres + (avis.reconfort != '' ? ', ' : '') + avis.reconfort + '.' }}</div>
                </v-flex>
                <v-flex xs12>
                    <pre style="font-family: 'Roboto'; white-space: pre-wrap;">{{avis.ceremonie}}</pre>
                </v-flex>
                <v-flex xs12>
                    <pre style="font-family: 'Roboto'; white-space: pre-wrap;">{{avis.veillance}}</pre>
                </v-flex>
                <v-flex xs12 v-if="avis.dons!=''">
                    <div>{{avis.dons}}</div>
                </v-flex>
                <v-flex xs12 v-if="avis.adresseFam !=''">
                    <div>Adresse de la famille : {{avis.adresseFam}}</div>
                </v-flex>
                <v-flex xs12 v-if="avis.fairePart!=''">
                    <div>{{avis.fairePart}}</div>
                </v-flex>
                <v-flex xs12 class="text-center">
                    <v-btn v-if="showButtonDocX" large color='green lighten-2' :loading="saveLoad" :disabled="saveLoad" @click.native="docx()">Créer docx</v-btn>
                    <v-btn large color='primary' :loading="saveLoad" :disabled="saveLoad" @click.native="save()">Sauvegarder</v-btn>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
        <v-snackbar :timeout="3000" success v-model="snackbar">Sauvegarde réussie !</v-snackbar>
</v-container>
</div>
</template>
<script>
    import {ajax_post} from '../../public/global.js'
    export default {
      data(){
        return{
            avis: {
                colonne: "4",
                photo: '',
                dateParution: '',
                adresseFact: '',
                petitText: '',
                symbole: '',
                famille: '',
                ainsi: '',
                ontLe: '',
                denom: '',
                quiSest: '',
                dateDeces: '',
                age: '',
                apres: '',
                reconfort: '',
                ceremonie: '',
                veillance: '',
                dons: '',
                fairePart: '',
                adresseFam: '',
                prix: ''
            },
            defunt: {
                titre: '',
                denom: '',
                photo: ''
            },
          petitText: [],
          ainsi: [],
          ontLe: [],
          veillance: '',
          quiSest: [],
          apres: [],
          age: [],
          reconfort: [],
          dons: [],
          fairePart: [],
          adrFam: [],
          adrFact: [],
          saveLoad: false,
          snackbar: false,
          showButtonDocX: false,
        }
      },
      props: ['sexe'],
      methods: {

        fetchData (){

            ajax_post(`/PHP/ajax/returnSaveAvisMortuaire.php`,`token=${this.$token()}&choice=return&id=${this.$route.params.id}`).then((response) =>{
                let rep = JSON.parse(response)
                if(!rep.error){
                    if(rep.data){
                        this.avis.colonne = rep.data.colonne
                        this.avis.photo = rep.data.photo
                        this.avis.dateParution = rep.data.date_parution
                        this.avis.adresseFact = rep.data.adresse_facturation
                        this.avis.petitText = rep.data.petit_texte
                        this.avis.symbole = rep.data.symbole
                        this.avis.famille = rep.data.famille
                        this.avis.ainsi = rep.data.ainsi_que
                        this.avis.ontLe = rep.data.ont_le
                        this.avis.denom = rep.data.denom
                        this.avis.quiSest = rep.data.qui_sest
                        this.avis.age = rep.data.age
                        this.avis.apres = rep.data.apres
                        this.avis.reconfort = rep.data.reconfort
                        this.avis.ceremonie = rep.data.ceremonie
                        this.avis.veillance = rep.data.veillance
                        this.avis.dons = rep.data.dons
                        this.avis.fairePart = rep.data.faire_part
                        this.avis.adresseFam = rep.data.adresse_famille
                    }else{
                        this.createVeillCerem('tout')
                    }
                }else{
                    this.$root.$emit('myinfo', {title: "Serenity", msg: rep.msg, color: "error"})
                }
            })

            ajax_post(`/PHP/ajax/returnTextAvisMortuaire.php`,`token=${this.$token()}`).then((response) =>{
                let rep = JSON.parse(response)
                if(!rep.error){
                    let returnText = rep.data
                    let selfPetitText = []
                    let selfAinsi = []
                    let selfOntLe = []
                    let selfQuiSest = []
                    let selfApres = []
                    let selfReconfort = []
                    let selfDons = []
                    let selfFairePart = []

                    returnText.forEach(element => {
                      if (element.designation=='petit_text' && element.sexe==this.sexe){
                          selfPetitText.push(element.texte)
                      }
                      if (element.designation=='ainsi'){
                          selfAinsi.push(element.texte)
                      }
                      if (element.designation=='ont_le'){
                          selfOntLe.push(element.texte)
                      }
                      if (element.designation=='qui_sest' && element.sexe==this.sexe){
                          selfQuiSest.push(element.texte)
                      }
                      if (element.designation=='apres'){
                          selfApres.push(element.texte)
                      }
                      if (element.designation=='reconfort' && element.sexe==this.sexe){
                          selfReconfort.push(element.texte)
                      }
                      if (element.designation=='dons'){
                          selfDons.push(element.texte)
                      }
                      if (element.designation=='faire_part'){
                          selfFairePart.push(element.texte)
                      }
                    })
                    this.petitText = selfPetitText
                    this.ainsi = selfAinsi
                    this.ontLe = selfOntLe
                    this.quiSest = selfQuiSest
                    this.apres = selfApres
                    this.reconfort = selfReconfort
                    this.dons = selfDons
                    this.fairePart = selfFairePart
                }else{
                    this.$root.$emit('myinfo', {title: "Serenity", msg: rep.msg, color: "error"})
                }   
            })

            ajax_post(`/PHP/ajax/returnDefAndServ.php`,`token=${this.$token()}&id=${this.$route.params.id}`).then((response) =>{
                let rep = JSON.parse(response)
                if(!rep.error){
                    let defuntRecup = rep.data
                    let dateDeces = new Date(defuntRecup.date_deces)
                    this.avis.dateDeces = defuntRecup.date_deces
                    let dateNaiss = new Date(defuntRecup.date_naissance)
                    // this.avis.dateDeces = 'le ' + dateDeces.toLocaleDateString('fr-CH', {weekday: "long", month: "long", day: "numeric", year: "numeric"}).replace(',','')
                    let age = dateDeces.getFullYear() - dateNaiss.getFullYear()
                    let m = dateDeces.getMonth() - dateNaiss.getMonth()
                    if(m < 0 || (m === 0 && dateDeces.getDate() < dateNaiss.getDate())){
                        age--
                    }
                    this.age.push("à l'âge de " + age + " ans")
                    this.age.push("dans sa " + (age + 1) + "ème année")

                    this.defunt.titre = defuntRecup.titre
                    if(defuntRecup.sexe == 'Féminin' && defuntRecup.nom_jf != ''){
                        this.defunt.denom = defuntRecup.prenom + ' ' + defuntRecup.nom + ' - ' + defuntRecup.nom_jf
                    }else{
                        this.defunt.denom = defuntRecup.prenom + ' ' + defuntRecup.nom
                    }
                    this.avis.denom = this.defunt.titre + '\n' + this.defunt.denom
                    this.defunt.photo = defuntRecup.photo
                }else{
                    this.$root.$emit('myinfo', {title: "Serenity", msg: rep.msg, color: "error"})
                } 
            })

            ajax_post(`/PHP/ajax/returnContacts.php`,`token=${this.$token()}&id=${this.$route.params.id}`).then((response) =>{
                let rep = JSON.parse(response)
                if(!rep.error){
                    let contactsRecup = rep.data.contacts
                    let selfAdrFam = []
                    let selfAdrFact = []
                    for (let i = 0; i < contactsRecup.length; i++) {
                        selfAdrFact.push(contactsRecup[i].titre + ' ' + contactsRecup[i].prenom + ' ' + contactsRecup[i].nom + ', ' + contactsRecup[i].adresse + ', ' + contactsRecup[i].cp + ' ' + contactsRecup[i].loc + ' #' + contactsRecup[i].tel1)
                        selfAdrFam.push(contactsRecup[i].titre + ' ' + contactsRecup[i].prenom + ' ' + contactsRecup[i].nom + ', ' + contactsRecup[i].adresse + ', ' + contactsRecup[i].cp + ' ' + contactsRecup[i].loc)
                    }
                    this.adrFam = selfAdrFam
                    this.adrFact = selfAdrFact
                }else{
                    this.$root.$emit('myinfo', {title: "Serenity", msg: rep.msg, color: "error"})
                } 
            })
        },

        saveNext(){
            this.saveLoad = true
            ajax_post(`/PHP/ajax/returnSaveAvisMortuaire.php`,`token=${this.$token()}&choice=save&id=${this.$route.params.id}&colonne=${this.avis.colonne}&photo=${this.avis.photo}&dateParution=${this.avis.dateParution}&adresseFact=${this.avis.adresseFact}&petitText=${this.avis.petitText}&symbole=${this.avis.symbole}&famille=${this.avis.famille}&ainsiQue=${this.avis.ainsi}&ontLe=${this.avis.ontLe}&denom=${this.avis.denom}&quiSest=${this.avis.quiSest}&dateDeces=${this.avis.dateDeces}&age=${this.avis.age}&apres=${this.avis.apres}&reconfort=${this.avis.reconfort}&ceremonie=${this.avis.ceremonie}&veillance=${this.avis.veillance}&dons=${this.avis.dons}&fairePart=${this.avis.fairePart}&adresseFam=${this.avis.adresseFam}`).then((response) =>{
                let rep = JSON.parse(response)
                if(!rep.error){
                    this.saveLoad = false
                    this.showButtonDocX = true
                    this.$root.$emit('myinfo', {title: "Serenity", msg: "Sauvegarde réussie !", color: ""})
                }else{
                    this.saveLoad = false
                    this.$root.$emit('myinfo', {title: "Serenity", msg: rep.msg, color: "error"})
                }
            })
        },
         docx(){
             window.open("/PHP/docx/avisMortuaire.php?id=" + this.$route.params.id + "&token=" + this.$token())
         },

        createVeillCerem(quoi){
            ajax_post(`/PHP/ajax/returnDefAndServ.php`,`token=${this.$token()}&id=${this.$route.params.id}`).then((response) =>{
                let rep = JSON.parse(response)
                if(!rep.error){
                    let defuntRecup = rep.data
                    let ceremonie = ''
                    let urne = ''
                    let ceremonieQuand = ''
                    let veillance = ''
                    let dateDeces = new Date(defuntRecup.date_deces)
                    this.avis.dateDeces = 'le ' + dateDeces.toLocaleDateString('fr-CH', {weekday: "long", month: "long", day: "numeric", year: "numeric"}).replace(',','')
                    if(defuntRecup.ceremonie_urne==1){
                        urne = " en présence de l'urne"
                    }
                    if(defuntRecup.ceremonie==1){
                        if(defuntRecup.ceremonie_intim==1){
                            ceremonie = "La cérémonie et l'incinération ont eu lieu dans l'intimité."
                            ceremonieQuand = ''
                        }else{
                            if(defuntRecup.type_ceremonie=="office de sépulture"){
                                ceremonie = "L'office de sépulture sera célébré" + urne
                            }
                            if(defuntRecup.type_ceremonie=="dernier Adieu"){
                                ceremonie = "Le dernier Adieu sera célébré" + urne
                            }
                            if(defuntRecup.type_ceremonie=="liturgie de la parole"){
                                ceremonie = "La liturgie de la parole sera célébrée" + urne
                            }
                            if(defuntRecup.type_ceremonie=="culte"){
                                ceremonie = "Le culte sera célébré" + urne
                            }
                            if(defuntRecup.type_ceremonie=="messe d'enterrement"){
                                ceremonie = "La messe d'enterrement sera célébrée" + urne
                            }
                            let dateCerem = new Date(defuntRecup.ceremonie_date + 'T' + defuntRecup.ceremonie_heure)
                            
                            ceremonieQuand = ' ' + defuntRecup.ceremonie_lieu + ', à ' + defuntRecup.ceremonie_loc + ', le ' + dateCerem.toLocaleDateString('fr-CH', {weekday: "long", month: "long", day: "numeric", year: "numeric"}).replace(',','') + ', à ' + dateCerem.toLocaleTimeString('fr-CH', {hour: '2-digit', minute:'2-digit'}).replace(':','h')
                            
                            if(defuntRecup.inc_inh=='incineration'){
                                ceremonieQuand = ceremonieQuand + ". L'incinération suivra dans l'intimité."
                            }else{
                                ceremonieQuand = ceremonieQuand + ", suivi de l'inhumation au " + defuntRecup.cim_crem + '.'
                            }
                        }
                    }else{
                        ceremonie = "Le dernier adieu a eu lieu dans l'intimité de la famille."
                        ceremonieQuand = ''
                    }
                    
                    let dateVeillance = new Date(defuntRecup.veillance_date + 'T' + defuntRecup.veillance_heure)
                    let dateVeillanceFin = new Date(defuntRecup.veillance_date + 'T' + defuntRecup.veillance_heure_fin)
                    if(defuntRecup.veillance=='presence'){
                        veillance = (defuntRecup.sexe=="Féminin" ? "La défunte repose " : "Le défunt repose ") + defuntRecup.veillance_lieu + ', où la famille sera présente le ' + dateVeillance.toLocaleDateString('fr-CH', {weekday: "long", month: "long", day: "numeric"}) + ' de ' + dateVeillance.toLocaleTimeString('fr-CH', {hour: '2-digit', minute:'2-digit'}).replace(':','h') + ' à ' + dateVeillanceFin.toLocaleTimeString('fr-CH', {hour: '2-digit', minute:'2-digit'}).replace(':','h') + '.'
                    }else if(defuntRecup.veillance=='veille'){
                        veillance = (defuntRecup.sexe=="Féminin" ? "La défunte repose " : "Le défunt repose ") + defuntRecup.repos_corps + ".\nVeillée de prières le " + dateVeillance.toLocaleDateString('fr-CH', {weekday: "long", month: "long", day: "numeric"}) + ' à ' + dateVeillance.toLocaleTimeString('fr-CH', {hour: '2-digit', minute:'2-digit'}).replace(':','h') + ' ' + defuntRecup.veillance_lieu + '.'
                    }

                    if(quoi == 'ceremonie'){
                        this.avis.ceremonie = ceremonie + ceremonieQuand
                    }else if(quoi == 'veillance'){
                        this.avis.veillance = veillance
                    }else if (quoi == 'tout'){
                        this.avis.ceremonie = ceremonie + ceremonieQuand
                        this.avis.veillance = veillance
                    }
                    
                }
            })
        },
        setPrix(){
            if(this.avis.colonne==4){
                this.avis.prix = Math.round((this.$refs['test'].clientHeight -40) / 1.35)
            }else{
                this.avis.prix = (Math.round((this.$refs['test'].clientHeight -40) / 1.35)) / 2
            }
        },
        save(){
          setTimeout(() => {
            this.saveNext()
          }, 0)
        }

      },
      computed: {
          colonne : function(){
              if(this.avis.colonne == 2){
                  return 325
              }else{
                  return 650
              }
          }
      },
      watch: {
          'avis': {
              handler: function(){
                this.showButtonDocX = false
                this.$nextTick(() => this.setPrix())
              },
              deep: true
          }
      },
      created() {
        this.fetchData()
      }
    }
</script>